import React from 'react'
import { Link } from 'react-router-dom'
import SEOHead from '../components/SEOHead'

export default function NotFound() {
  return (
    <>
      <SEOHead title="404 - Siden blev ikke fundet - Agstner Byg ApS" />
      <section className="min-h-[70vh] flex items-center justify-center py-20 bg-zinc-950 px-4">
        <div className="max-w-xl mx-auto text-center space-y-6">
          <div className="w-20 h-20 bg-orange-500 text-zinc-950 font-display flex items-center justify-center mx-auto text-3xl font-black">
            404
          </div>
          <h1 className="text-3xl sm:text-4xl font-display font-bold text-white uppercase tracking-tight">
            Siden blev ikke fundet
          </h1>
          <p className="text-zinc-300 text-xs sm:text-sm leading-relaxed">
            Beklager, den side du leder efter eksisterer ikke eller er blevet flyttet. Du kan benytte genvejene herunder til at komme videre.
          </p>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 pt-4 text-xs font-display font-bold uppercase tracking-wider">
            <Link to="/" className="p-3 bg-zinc-900 border border-zinc-800 hover:border-orange-500 text-white transition-all">
              Forside
            </Link>
            <Link to="/tomrerarbejde" className="p-3 bg-zinc-900 border border-zinc-800 hover:border-orange-500 text-white transition-all">
              Tømrerarbejde
            </Link>
            <Link to="/tag" className="p-3 bg-zinc-900 border border-zinc-800 hover:border-orange-500 text-white transition-all">
              Tag
            </Link>
            <Link to="/renovering" className="p-3 bg-zinc-900 border border-zinc-800 hover:border-orange-500 text-white transition-all">
              Renovering
            </Link>
            <Link to="/projekter" className="p-3 bg-zinc-900 border border-zinc-800 hover:border-orange-500 text-white transition-all">
              Projekter
            </Link>
            <Link to="/kontakt" className="p-3 bg-orange-500 text-zinc-950 font-bold border border-orange-500 hover:bg-orange-600 transition-all">
              Få et tilbud
            </Link>
          </div>

          <div className="pt-6 border-t border-zinc-800 text-xs text-zinc-400">
            Du kan også altid ringe direkte til os på{' '}
            <a href="tel:+4552502543" className="text-orange-500 font-bold whitespace-nowrap hover:underline">
              52 50 25 43
            </a>
          </div>
        </div>
      </section>
    </>
  )
}
